var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOliveBranch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 26.3862 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2158 16.4912C19.2158 16.4912 17.3318 14.1922 18.551 11.0013C19.768 7.80842 22.6141 6.59649 22.6141 6.59649C22.6141 6.59649 24.7401 9.3344 23.5507 12.4468C22.3677 15.5591 19.2158 16.4912 19.2158 16.4912Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.586 18.1404C13.586 18.1404 10.286 17.8851 8.39421 15.0584C6.50454 12.2318 7.94895 9.07018 7.94895 9.07018C7.94895 9.07018 11.0125 9.66655 12.9554 12.5667C14.8941 15.4689 13.586 18.1404 13.586 18.1404Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3166 22.3146C14.9734 25.4968 13.1733 28.0351 13.1733 28.0351C13.1733 28.0351 9.65856 27.3557 8.04331 24.2568C6.435 21.1538 8.45233 18.1404 8.45233 18.1404C8.45233 18.1404 11.6597 19.1344 13.3166 22.3146Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.43558 24.7368C5.43558 24.7368 8.27568 26.055 9.48952 29.517C10.7012 32.9768 8.80926 35.4561 8.80926 35.4561C8.80926 35.4561 5.66092 34.4365 4.47896 31.066C3.29701 27.6955 5.43558 24.7368 5.43558 24.7368Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.21175 42.0526C3.21175 42.0526 0.21224 40.2402 0.00916041 36.835C-0.191585 33.4299 2.97366 31.3333 2.97366 31.3333C2.97366 31.3333 5.55067 33.3345 5.76075 36.8288C5.9685 40.3231 3.21175 42.0526 3.21175 42.0526Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.9642 10.7193C14.9642 10.7193 11.8839 9.73287 10.9794 6.20716C10.0727 2.68144 11.8277 0 11.8277 0C11.8277 0 15.4006 1.24057 16.2826 4.68229C17.1646 8.11755 14.9642 10.7193 14.9642 10.7193Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.2555 23.9123C19.2555 23.9123 18.0978 21.0077 20.4041 18.1202C22.7172 15.2307 26.0311 14.8421 26.0311 14.8421C26.0311 14.8421 27.298 18.2684 25.044 21.085C22.79 23.9037 19.2555 23.9123 19.2555 23.9123Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.514 31.2242C16.514 31.2242 16.0957 28.2022 18.8466 25.9061C21.5997 23.6143 24.7156 23.9266 24.7156 23.9266C24.7156 23.9266 25.1168 27.4741 22.4341 29.7069C19.7515 31.9396 16.514 31.2242 16.514 31.2242Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.3684 37.924C12.3684 37.924 12.9284 34.9583 16.4749 33.616C20.026 32.2715 23.0877 33.4849 23.0877 33.4849C23.0877 33.4849 22.3365 36.9355 18.881 38.2445C15.4233 39.5557 12.3684 37.924 12.3684 37.924Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.023 39.9053C14.5555 38.9001 17.3158 40.5378 17.3158 40.5378C17.3158 40.5378 16.176 44.0996 12.7327 45.0894C9.28937 46.0681 6.59649 43.9842 6.59649 43.9842C6.59649 43.9842 7.49267 40.9129 11.023 39.9053Z",
    fill: "#F07AC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.2464 12.2892L15.8377 11.5439C15.9212 11.7097 24.084 28.2726 1.14508 47L0 45.7172C21.8334 27.8863 14.5673 12.9148 14.2464 12.2892Z",
    fill: "#F07AC5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOliveBranch);
export default __webpack_public_path__ + "static/media/olive-branch.da8c3790435c6ceb862a7b9574aa88c7.svg";
export { ForwardRef as ReactComponent };